import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { AggregatedStatus } from 'modules/integrations/lib/syncableStatus'
import { translatedAggregatedStatus } from 'modules/integrations/lib/translatedAggregatedStatus'

export const useTranslatedAggregatedStatus = () => {
  const { capabilityMode } = usePrivateIntegrationsSyncContext()
  const isExportMode = capabilityMode === 'file'

  return (status: AggregatedStatus): string => translatedAggregatedStatus(status, isExportMode)
}
